export default __webpack_public_path__ + "static/media/empty_permissions_section.742c5efb.svg";